(function () {
  'use strict';

  angular
    .module('app.account-use-delegation', [])

      .component('accountUseDelegation', {

        bindings: {
            device: '<'
        },

      /* @ngInject */
      templateUrl: ["AccountService", function (AccountService) {
        return AccountService.getLinks().AccountUseDelegation;
      }],
      /* @ngInject */
      controller: ["$scope", "$rootScope", "$location", "$window", "AccountService", "AppService", "HttpService", "toastr", function ($scope, $rootScope, $location, $window, AccountService, AppService, HttpService, toastr) {
        var ctrl = this;
        ctrl.formData = {};

        AccountService.initAccount(ctrl);

        ctrl.$onInit = function () {
          $scope.device = ctrl.device;
          ctrl.loading = true;

          AppService.getParams()
            .then(function (data) {
              ctrl.Visitor = data.Visitor;
            })
            .catch(function (error) {
              console.error(error);
            });

          HttpService.get({
            url: '/Account/GetDelegations',
            cache: false
          })
            .then(function (response) {
              if (response.status === 'OK') {
                ctrl.delegations = response.results.Delegations;
              } else {
                ctrl.delegations = [];
              }
              ctrl.loading = false;
            })
            .catch(function (error) {
              console.error(error);
            });
        };

        ctrl.submit = function () {
          HttpService.post({
            url: '/Account/ChangeDelegation',
            data: '"' + ctrl.formData.DelegationID + '"'
          })
            .then(function (response) {
                AppService.getTranslate()
                  .then(function (translate) {
                    if (response.status === 'OK') {
                      toastr.success('', translate.messages.DelegationModified, {
                        allowHtml: true,
                        extraData: {
                          template: 'toast_message.tpl'
                        }
                      });
                      $window.location.assign(ctrl.links.AccountHome).reload();
                    } else {
                      console.error('Unable to change delegation with delegationID', ctrl.formData.DelegationID);
                      toastr.error('', 'Error while changing profile', {
                        allowHtml: true,
                        extraData: {
                          template: 'toast_message.tpl'
                        }
                      });
                    }
                  });
            })
            .catch(function (error) {
              console.error(error);
            });
        }
      }],
      controllerAs: 'accountCtrl'
    });

})();
